import React from 'react';
import { Link } from 'react-router-dom';

const PaymentSuccess = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: '#f0f9ff',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        padding: '3rem',
        borderRadius: '12px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: '400px'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
        <h1 style={{ color: '#059669', marginBottom: '1rem' }}>
          Paiement réussi !
        </h1>
        <p style={{ color: '#6b7280', marginBottom: '2rem' }}>
          Votre abonnement DragueMaster a été activé avec succès.
        </p>
        <Link 
          to="/dashboard"
          style={{
            display: 'inline-block',
            background: '#3b82f6',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600'
          }}
        >
          Continuer vers le Dashboard →
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;